import { render, staticRenderFns } from "./TaskFormDetail.vue?vue&type=template&id=342346c2"
import script from "./TaskFormDetail.vue?vue&type=script&lang=js"
export * from "./TaskFormDetail.vue?vue&type=script&lang=js"
import style0 from "./TaskFormDetail.vue?vue&type=style&index=0&id=342346c2&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('342346c2')) {
      api.createRecord('342346c2', component.options)
    } else {
      api.reload('342346c2', component.options)
    }
    module.hot.accept("./TaskFormDetail.vue?vue&type=template&id=342346c2", function () {
      api.rerender('342346c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/flowable/task/TaskFormDetail.vue"
export default component.exports